export const U2000LUStateEnumNextAction = {
  NONE: "NONE",
  ADD: "ADD",
  MODIFY: "MODIFY",
} as const;
export type U2000LUStateEnumNextAction = (typeof U2000LUStateEnumNextAction)[keyof typeof U2000LUStateEnumNextAction];

export const U2000LUStateEnumAction = {
  SETPERSONALIZATION: "SETPERSONALIZATION",
  ACTIONORIGINFROM: "ACTIONORIGINFROM",
  NEXTACTION: "NEXTACTION",
} as const;

export interface U2000LUStatePersonalization {
  [key: string]: any;
}

export interface U2000LUState {
  personalization?: U2000LUStatePersonalization;
  nextAction: string;
  actionOriginFrom?: string;
}

export interface U2000LUAction {
  type: string;
  [key: string]: any;
}

function handleSetPersonalization(luState: U2000LUState, action: U2000LUAction): U2000LUState {
  const { personalization } = action.data;

  return {
    ...luState,
    personalization: personalization,
  };
}

function handleActionOriginFrom(luState: U2000LUState, action: U2000LUAction): U2000LUState {
  const { actionOriginFrom } = action.data;

  return {
    ...luState,
    actionOriginFrom: actionOriginFrom,
  };
}

function handleNextAction(luState: U2000LUState, action: U2000LUAction): U2000LUState {
  const { nextAction } = action.data;

  return {
    ...luState,
    nextAction: nextAction,
  };
}

const actionHandlers: Record<string, (luState: U2000LUState, action: U2000LUAction) => U2000LUState> = {
  [U2000LUStateEnumAction.SETPERSONALIZATION]: handleSetPersonalization,
  [U2000LUStateEnumAction.ACTIONORIGINFROM]: handleActionOriginFrom,
  [U2000LUStateEnumAction.NEXTACTION]: handleNextAction,
};

export default function u2000LUState(luState: U2000LUState, action: U2000LUAction): U2000LUState {
  const handler = actionHandlers[action.type];
  if (!handler) {
    throw new Error(`Unhandled action type: ${action.type}`);
  }
  return handler(luState, action);
}
